<label class="c-label ">
    <div class="c-select">
        <button class="c-select__title">{{selectedElement ? selectedElement.opis : 'Wybierz przyczynę'}}</button>
        <ul class="c-select__list o-list-bare {{optionPanelOpen ? 'is-open' : ''}}">
            <li *ngFor="let el of list" class="c-select__item {{selectedElement ? el.kod === selectedElement.kod ? 'is-selected' : '' : ''}}" (click)="onSelectionChange(el)">{{el.opis}}</li>
        </ul>
    </div>
</label>

<div *ngIf="input" class="o-flex__item u-flex-1/1@tablet u-flex-1/1@small mt-3">
  <form [formGroup]="causeFormGroup">
    <input formControlName="cause" placeholder="{{inputPlaceholder}}" class="c-input" (blur)="onInputChange()">
    <span *ngIf="validateLength(causeFormGroup.get('cause')?.errors)" class="c-label__title text-danger">W polu przyczyna odrzucenia możesz wprowadzić maksymalnie 255 znaków</span>
  </form>
</div>
